import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { sha512, sha384 } from 'js-sha512';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (typeof crypto === 'undefined') {
  window.crypto = {} as Crypto;
}
if (typeof crypto.randomUUID === 'undefined') {
  crypto.randomUUID = function randomUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function randomUUID_charRandomReplacer(c) {
      var replChar = Math.random() * 16 | 0, v = c === 'x' ? replChar : (replChar & 0x3 | 0x8);
      return replChar.toString(16);
    }) as `${string}-${string}-${string}-${string}-${string}`;
  }
}
if (typeof crypto.getRandomValues === 'undefined') {
  crypto.getRandomValues = function getRandomValues(array) {
    if (!(array instanceof Int8Array || array instanceof Uint8Array || array instanceof Int16Array || array instanceof Uint16Array || array instanceof Int32Array || array instanceof Uint32Array || array instanceof Uint8ClampedArray)) {
      throw new Error('Expected an integer array')
    }
    const rndNumber = () => Math.random() * 0x100000000;
    let r = rndNumber();
    for (let i = 0; i < array.length; i++) {
      if ((i & 0x03) === 0) {
        r = rndNumber();
      }
      array[i] = (r >>> ((i & 0x03) << 3)) & 0xff
    }
    return array;
  }
}
if (typeof crypto.subtle === 'undefined') {
  (crypto as any)['subtle'] = {};
}
if (typeof crypto.subtle.digest === 'undefined') {
  const Digest = (window as any)['Digest'];
  const sha1 = Digest.SHA1().digest;
  const sha256 = Digest.SHA256().digest;
  crypto.subtle.digest = (algorithm: AlgorithmIdentifier, data: BufferSource): Promise<ArrayBuffer> => {
    return new Promise((resolve, reject) => {
      switch (algorithm) {
        case "SHA-1":
          resolve(sha1(data));
          break;
        case "SHA-256":
          resolve(sha256(data));
          break;
        case "SHA-384":
          resolve(sha384(data as any) as any);
          break;
        case "SHA-512":
          resolve(sha512(data as any) as any);
          break;
      }
      reject(new Error(`unsupported algorithm - ${algorithm}`));
    });
  }
}

if (environment.production) {
  enableProdMode();
}

const platformRef = platformBrowserDynamic();

// (function() {
//   class simpleXhrFactory extends XhrFactory {
//     //qwe = inject(APP_BASE_HREF);
    
//     override build(): XMLHttpRequest {
//       return new XMLHttpRequest;
//     }
//   }
//   let f = new simpleXhrFactory;
//   const http = new HttpClient(new HttpXhrBackend(f));
//   //log(f.qwe);

//   runInInjectionContext(platformRef.injector, () => {
//     @NgModule({
//       imports: [BrowserModule],
//       providers: [{
//         provide: APP_BASE_HREF,
//         useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
//         deps: [PlatformLocation]
//       }]
//     })
//     class app implements DoBootstrap {
//       constructor(@Inject(APP_BASE_HREF) public baseHref: string) {}
//       ngDoBootstrap(appRef: ApplicationRef): void {
//         log(this.baseHref);
//       }
//     }
//     platformRef.bootstrapModule(app).catch(err => console.error(err));
//     //log(inject(APP_BASE_HREF));
//   })


  

//   // const u = APP_BASE_HREF + '/assets/environment.json';
//   // log(u);
//   // const t = (new DefaultUrlSerializer).parse(u);
//   // log(t);
//   // log(t.toString());


//   http.get('/assets/environment.json').subscribe(resp => {
//     log(resp);
//   })
// })();

platformRef.bootstrapModule(AppModule).catch(err => console.error(err));

